import React from 'react';
import styled, { css } from 'styled-components';
import '@fontsource/montserrat';
import { TrademarksPackage } from '_constants/trademarksPackage';
import { theme } from '_constants/theme';
import Icon from 'components/atomic/Icon';
import { ICONS_ALIASES } from '_constants/icons';

const { colors, fontSizes, spaces } = theme;
const StyledBoxContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 53%;
  box-shadow: 0px 5px 15px 0px #a8a8a826;
  border: solid 5px;
  border-color: ${({ color }) => (color ? '#03589C4D' : 'transparent')};
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  gap: 8px;
  @media (max-width: 768px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;
const StyledPackageName = styled.div`
  font-family: Montserrat;
  font-weight: 600;
  font-size: 18px;
  color: ${({ color }) => (color ? colors.blue[750] : colors.orange[450])};
`;
const StyledPrice = styled.div`
  font-family: Montserrat;
  font-weight: 600;
  color: ${colors.blue[750]};
  font-size: 36px;
`;
const StyledAdditionalText = styled.div`
  color: ${colors.gray[450]};
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 600;
`;
const StyledPriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const StyledButton = styled.div`
  font-family: Montserrat;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  padding: 12px 36px;
  border-radius: 4px;
  text-decoration: none;
  cursor: pointer;
  background: ${({ color }) => (color ? colors.blue[750] : colors.orange[450])};
  color: ${colors.white};
  text-align: center;
`;
const StyledButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const StyledProcessingContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  color: ${colors.gray[450]};
  font-size: 14px;
  font-family: Montserrat;
  font-weight: 600;
`;
const StyledDetailsContainer = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding-top: 24px;
    padding-left: 8px;
    padding-right: 8px;
  }
`;
const StyleCell = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    border: none;
  }
`;
const StyleHeader = styled.div`
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${colors.blue[750]};
`;
const StyleText = styled.div`
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: ${colors.gray[450]};
`;
const StyleRow = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: 16px;
  }
`;
const BasicBox4 = ({
  onChange,
  price,
  processingTime,
  name,
  selected,
  main,
  details,
}) => {
  return (
    <StyledBoxContainer color={main}>
      <StyledBox>
        <StyledPackageName color={main}>{name} Package</StyledPackageName>
        <StyledPriceContainer>
          <StyledAdditionalText>For just</StyledAdditionalText>
          <StyledPrice>${price}</StyledPrice>
        </StyledPriceContainer>
        <StyledAdditionalText>+ USPTO filing fees*</StyledAdditionalText>
        <StyledButtonContainer>
          <StyledButton color={main} onClick={() => onChange(selected)}>
            Choose Package
          </StyledButton>
        </StyledButtonContainer>
        <StyledProcessingContainer>{processingTime}</StyledProcessingContainer>
        {details && (
          <StyledDetailsContainer>
            {TrademarksPackage &&
              TrademarksPackage.map(
                (item, j) =>
                  item[selected] === 1 && (
                    <StyleRow key={j}>
                      <StyleCell>
                        <Icon
                          alias={ICONS_ALIASES.starCheck}
                          color={main ? colors.blue[750] : colors.orange[450]}
                          width="32px"
                          height="32px"
                        />
                      </StyleCell>
                      <StyleCell>
                        <StyleHeader>{item.header}</StyleHeader>
                        <StyleText>{item.text}</StyleText>
                      </StyleCell>
                    </StyleRow>
                  )
              )}
          </StyledDetailsContainer>
        )}
      </StyledBox>
    </StyledBoxContainer>
  );
};

export default BasicBox4;
